import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper";

import banner1 from "../static/images/banner1.jpg";
import banner2 from "../static/images/banner2.jpg";
import banner3 from "../static/images/banner3.jpg";
import banner4 from "../static/images/banner4.jpg";

export default () => {
  const screenWidth = window.innerWidth;
  const pagination = {
    el: ".swiper-pagination-container",
    clickable: true,
  };
  return (
    <Swiper
      navigation={{
        prevEl: ".slide_prev",
        nextEl: ".slide_next",
      }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      pagination={pagination}
      spaceBetween={screenWidth >= 1024 ? 20 : 5}
      slidesPerView={
        screenWidth >= 768 && screenWidth < 1024
          ? 1.5
          : screenWidth >= 1024
          ? 1.1
          : 1
      }
      centeredSlides={screenWidth >= 768 && screenWidth < 1024 ? true : false}
      onSlideChange={() => console.log("single_slide change")}
      onSwiper={(swiper) => console.log(swiper)}
      modules={[Autoplay, Pagination, Navigation]}
      loop={true}
      className="swiper_container relative h-full"
    >
      <SwiperSlide className="single_slide">
        <img
          src={banner1}
          className="w-full h-full object-cover"
          alt="banner"
        />
      </SwiperSlide>
      <SwiperSlide className="single_slide">
        <img
          src={banner2}
          className="w-full h-full object-cover"
          alt="banner"
        />
      </SwiperSlide>
      <SwiperSlide className="single_slide">
        <img
          src={banner3}
          className="w-full h-full object-cover"
          alt="banner"
        />
      </SwiperSlide>
      <SwiperSlide className="single_slide">
        <img
          src={banner4}
          className="w-full h-full object-cover"
          alt="banner"
        />
      </SwiperSlide>
      <div className="bg_layer">&nbsp;</div>
      <div className="swiper_controls lg:w-[90%]  z-20 translate-y-8 lg:flex justify-between items-center ">
        <div className="swiper-pagination-container"></div>
        <div className="hidden lg:flex">
          <button className="slide_prev py-3 px-4 text-black border border-black hover:bg-black hover:text-white ease-in duration-100">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <button className="slide_next py-3 px-4 ml-4 text-black border border-black hover:bg-black hover:text-white ease-in duration-100">
            <i class="fa-solid fa-chevron-right "></i>
          </button>
        </div>
      </div>
    </Swiper>
  );
};
